module.exports = __webpack_public_path__ + "img/ellipsis-icon.00b92c4b.svg";